import { useState } from "react";
import { Flag, X } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

const REASONS = [
  { value: "faux_profil", label: "Faux profil / usurpation d'identité" },
  { value: "harcelement", label: "Harcèlement, menaces ou intimidation" },
  { value: "arnaque", label: "Arnaque / demande d'argent" },
  { value: "contenu_inapproprie", label: "Contenu inapproprié" },
  { value: "autre", label: "Autre comportement déplacé" },
];

export const ReportModal = ({ target, context, onClose }) => {
  const [reason, setReason] = useState("");
  const [detail, setDetail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (!reason || sending) return;
    setSending(true);
    try {
      await api.post("/reports", { target_id: target.id, reason, context, detail: detail.trim() || undefined });
      toast.success("Signalement envoyé. Notre équipe l'examine avec sérieux et dans les meilleurs délais.");
      onClose(true);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-plum/60 px-4 backdrop-blur-sm" data-testid="report-modal" onClick={() => onClose(false)}>
      <div className="w-full max-w-md rounded-3xl border border-gold/40 bg-cream p-7 shadow-card" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <p className="font-cinzel text-[10px] tracking-[0.3em] text-gold">SIGNALEMENT</p>
            <h2 className="mt-1 font-serif text-xl font-semibold text-ink">Signaler {target.name}</h2>
          </div>
          <button onClick={() => onClose(false)} data-testid="report-close-button" aria-label="Fermer" className="rounded-full p-1.5 text-clay transition-colors hover:bg-terra/10 hover:text-terra">
            <X size={17} />
          </button>
        </div>
        <p className="mt-2 text-xs leading-relaxed text-clay">Votre signalement est transmis à notre équipe de modération. Il reste confidentiel.</p>
        <div className="mt-4 space-y-2" data-testid="report-reasons">
          {REASONS.map((r) => (
            <label key={r.value} className={`flex cursor-pointer items-center gap-3 rounded-xl border px-4 py-2.5 text-sm transition-colors ${reason === r.value ? "border-terra bg-terra/10 font-semibold text-ink" : "border-terra/15 bg-white text-clay hover:border-terra/40"}`}>
              <input type="radio" name="report-reason" value={r.value} checked={reason === r.value} onChange={() => setReason(r.value)} className="accent-[#C86D51]" data-testid={`report-reason-${r.value}`} />
              {r.label}
            </label>
          ))}
        </div>
        <textarea
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          data-testid="report-detail-input"
          placeholder="Précisions facultatives (contexte, date, contenu du message…)"
          rows={3}
          maxLength={500}
          className="mt-3 w-full rounded-xl border border-terra/20 bg-white px-4 py-3 text-sm outline-none focus:border-terra"
        />
        <button
          onClick={submit}
          disabled={!reason || sending}
          data-testid="report-submit-button"
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-plum px-6 py-3 text-sm font-semibold text-cream transition-colors hover:bg-ink disabled:cursor-not-allowed disabled:opacity-40"
        >
          <Flag size={15} /> {sending ? "Envoi…" : "Envoyer le signalement"}
        </button>
      </div>
    </div>
  );
};
